import React from 'react'

import Icon from './Icon'
import type { IconProps } from './Icon'
import { ReactComponent as CheckCircle } from 'assets/svg/icon-check-circle.svg'

function IconCheckCircle(props: IconProps): JSX.Element {
  const title = 'icon-check-circle'
  const {
    className,
    id = title,
    name = title,
    variants = 'md',
    ...others
  } = props

  const svgProps = { id, name }

  return (
    <Icon className={className} variants={variants} {...others}>
      <CheckCircle {...svgProps} data-testid={title} />
    </Icon>
  )
}

export default IconCheckCircle
